// src/components/dashboard/DashboardLayout.js
import React from 'react';

/**
 * Dashboard Layout Component
 * Wrapper for dashboard content with consistent spacing and responsive grid
 *
 * @param {ReactNode} children - Dashboard content
 */
const DashboardLayout = ({ children }) => {
  return (
    <div className="space-y-6">
      {children}
    </div>
  );
};

/**
 * KPI Grid Section
 * Responsive grid for KPI cards (2x2 on mobile, 4 across on desktop)
 */
export const KpiGrid = ({ children }) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-4">
      {children}
    </div>
  );
};

/**
 * Charts Grid Section
 * Responsive grid for charts and visualizations
 */
export const ChartsGrid = ({ children, columns = 1 }) => {
  const gridClasses = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 lg:grid-cols-2',
    3: 'grid-cols-1 lg:grid-cols-3'
  };

  return (
    <div className={`grid ${gridClasses[columns]} gap-4 lg:gap-6`}>
      {children}
    </div>
  );
};

export default DashboardLayout;
